import React from 'react';
import { GoogleMap, useLoadScript } from '@react-google-maps/api';
import { Box, Typography } from '@mui/material';

import { Spinner } from '../../StyledComponents';

// const options = {
//     zoomControlOptions: {
//         position: window.google.maps.ControlPosition.RIGHT_CENTER
//     }
// };

type PropsType = {
    height?: number | string
};

const center = {
    lat: 61,
    lng: 18
};

const MyMap: React.FC<PropsType> = (props: PropsType) => {
    const { height = 500 } = props;
    // const { isLoaded, loadError } = useLoadScript({
    //     googleMapsApiKey: 'AIzaSyAuGKaL8YtUG-9jjZjKgha22Redp71SUyc'
    // });
    const isLoaded = true;

    const [map, setMap] = React.useState(null);

    const onLoad = React.useCallback((newMap) => {
        const bounds = new window.google.maps.LatLngBounds();
        newMap.fitBounds(bounds);
        setMap(newMap);
    }, []);

    const onUnmount = React.useCallback(() => {
        setMap(null);
    }, []);

    // if (loadError) {
    //     return <div>Kunde inte ladda kartan.</div>;
    // }

    return (
        isLoaded
            ? (
                <GoogleMap
                    mapContainerStyle={{ height, overflow: 'visible' }}
                    center={center}
                    // options={options}
                    onLoad={onLoad}
                    onUnmount={onUnmount}
                >
                    <div>Hej</div>
                </GoogleMap>
            ) : (
                <Box
                    sx={{
                        height,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <Spinner />
                </Box>
            )
    );
};

export default MyMap;
